import { ENV } from "@/constants";
import { ENVIRONMENTS } from "@/constants";
import { StudioServiceMock } from "./mocks/studio.service.mock";
import { StudioServiceBackend } from "./backend/studio.service.backend";
import { Route } from "@/model/route.model";

export interface StudioService {
    getRouters(): Promise<Route[]>;
    getImage(oid: string): string;
    addNewView(oid: string, token: string): void;
}

const studioService = ENV == ENVIRONMENTS.PROD ? new StudioServiceBackend() : new StudioServiceMock();

export default studioService;